export default __webpack_public_path__ + "static/media/Ajay V. Dattani .022d050e.jpg";